import addRoute from '@/router/add-route';

const Users = () => import('@/modules/users/users.vue');
const UsersForm = () => import('@/modules/users/user-form.vue');

const users = [
    addRoute({
        name: 'users',
        path: '/users',
        component: Users,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'add-user',
        path: '/users/add',
        component: UsersForm,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'update-user',
        path: '/users/update/:id',
        component: UsersForm,
        root: {label: 'Settings', name: 'settings'},
    }),
];

export default users;
